<template>
    <div class="activityIndex activityPage">
        <div class="back" v-if="terminal != 5" @click="back">
            <img src="../../assets/activity_back.png">
        </div>
        <div class="rule" @click="ruleShow = true">活动规则</div>
        <div class="pic">
            <img src="../../assets/activity_bj.png" alt="">
        </div>
        <div class="button" v-if="notGet">
            <img src="../../assets/activity_btn.png" alt="" @click="getBtn">
        </div>

        <vant-popup round style="width:80%;" v-model="ruleShow">
            <div class="rulePopup">
                <div v-if="activityInfo">{{activityInfo.remark}}</div>
            </div>
        </vant-popup>

        <div class="mask" v-if="!notGet"></div>

        <!-- 领取礼包 -->
        <div class="get-coupon" v-if="!notGet">
            <div class="coupon-box">
                <div class="white">
                    <template v-for="(item,index) in couponInfo">
                        <div class="content" :key="index">
                            <img :src="item.iconUrl" alt="">
                        </div>
                    </template>
                </div>
            </div>
            <div class="get">{{couponInfo.remark}}</div>
            <div class="confirm" @click="back">确定</div>
        </div>
    </div>
</template>


<script>
import { Popup, Toast } from 'vant'
import { GetActivity, GetCoupon } from '@/api/activity'

export default {
    components: { 
        vantPopup: Popup,
        Toast
    },
    data(){
        return {
            terminal: null, // 访问来源
            userId: null, 
            userToken: null,
            activeid:null, 
            activityInfo: null,
            ruleShow: false,
            notGet: true, // 还未领取
            couponInfo: '',
        }
    },
    mounted(){
        this.terminal = this.$route.query.terminal
        if(this.terminal == 5) {
            const query = JSON.parse(this.$route.query.jsonQuery)
            this.userId = query.userId
            this.userToken = query.userToken
            this.activeid = query.activityId
        } else {
            this.getUserInfo()
            this.getTokenInfo()
            this.getClickActiveInfo()
        }
        setTimeout(() => {
            this.getActivity()
        },1000)
    },
    methods: {
        // 约定APP方法-获取用户方法
        getUserInfo() {
            DYL.getUserInfo(window['success'] = (data) => {
                if(typeof data != 'object'){
                    data = JSON.parse(data)
                }
                this.userId=data.id
            })
        },
        // 约定APP方法-获取用户Token
        getTokenInfo() {
            DYL.getTokenInfo(window['success'] = (data) => {
                if (typeof data != 'object') {
                    data = JSON.parse(data)
                }
                this.userToken = data.access_token
            })
        },
        // 约定APP方法-获取点击的活动
        getClickActiveInfo() {
            DYL.getClickActiveInfo(window['success'] = (data) => {
                if (typeof data != 'object') {
                    data = JSON.parse(data);
                }
                this.activeid = data.activeid
                this.terminal = data.terminal
            })
        },
        back() {
            if(this.terminal == 5){
                uni.switchTab({
                    url: '/pages/index/index'
                })
            } else {
                DYL.backWebView()
            }
        },
        // 获取活动详情
        async getActivity() {
            const res = await GetActivity({activityId: this.activeid, terminal:this.terminal})
            if(res.code == 200){
                this.activityInfo = res.data
            } else {
                Toast(res.msg)
            }
        },
        // 领取卡券
        getBtn() {
            const userToken = this.userToken
            GetCoupon({
                userId: this.userId,
                activityId: this.activeid,
                terminal: this.terminal
                },userToken).then(res=>{
                if(res.code == 200){
                    this.couponInfo = res.data
                    this.notGet = false
                } else {
                    Toast(res.msg)
                }
            })
        }
    }
}
</script>


<style lang="scss" scoped>
@import '../../css/activity.scss';
.activityIndex{
    .rule {
        background: rgba(255,255,255, .7);
        position: absolute;
        left: 16px;
        top: 103px;
        padding: 5px 10px;
        border-radius: 5px;
    }
    .rulePopup { padding: 20px; }
    .button {
        position: absolute;
        bottom: 10vh;
        left: 50%;
        transform: translate(-50%);
        width: 41vw;
        height: 11.1vw;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .mask {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.7);
        left: 0;
        top: 0;
    }
    .get-coupon {
        position: absolute;
        z-index: 1;
        text-align: center;
        top: 45vw;
        width: 100%;
        .coupon-box {
            width: 84vw;
            margin: 90px auto 80px;
            background: url(../../assets/activity_coupon1.png) no-repeat;
            background-size: cover;
            padding: 11px 8px;
            box-sizing: border-box;
            .white {
                background: #fff;
                padding: 20px 0 10px;
                width: 100%;
            }
            .content {
                width: 76vw;
                height: 25.7vw;
                margin: 0 auto;
                img {
                    max-width: 100%;
                    max-height: 100%;
                }
            }
        }
    }
}

</style>

